<ion-header>
  <ion-toolbar class="ion-justify-content-center"
    style="--background: var(--ion-color-toolbar-primary); color: var(--ion-title-color);">
    <ion-title>{{ component.alias }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="modalCtrl.dismiss()">
        <ion-icon name="close-outline" style="color: var(--ion-title-color);"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  @if (!loading) {
    <form [formGroup]="formGroup">
      <ion-card-content class="underline">
        <table class="full_width">
          <tr>
            <td style="width: 65%" translate>
              EDGE.INDEX.WIDGETS.DELAYED_SELL_TO_GRID.SELL_TO_GRID_POWER_LIMIT
            </td>
            <td style="width: 35%" class="align_right">
              <ion-item lines="inset" class="noPadding">
                <ion-input class="regularFont" type="number" formControlName="sellToGridPowerLimit"
                  style="text-align: end;" label="&nbsp;W">
                </ion-input>
              </ion-item>
            </td>
          </tr>
        </table>
      </ion-card-content>
      <ion-card-content class="underline">
        <table class="full_width">
          <tr>
            <td style="width: 65%" translate>
              EDGE.INDEX.WIDGETS.DELAYED_SELL_TO_GRID.CONTINUOUS_SELL_TO_GRID_POWER
            </td>
            <td style="width: 35%" class="align_right">
              <ion-item lines="inset" class="noPadding">
                <ion-input class="regularFont" type="number" formControlName="continuousSellToGridPower"
                  style="text-align: end;" label="&nbsp;W">
                </ion-input>
              </ion-item>
            </td>
          </tr>
        </table>
      </ion-card-content>
      @if (formGroup.dirty) {
        <ion-fab class="ion-padding-bottom" vertical="bottom" horizontal="end" slot="fixed">
          <ion-fab-button (click)="applyChanges()">
            <ion-icon size="large" name="checkmark-circle-outline">
            </ion-icon>
          </ion-fab-button>
        </ion-fab>
      }
    </form>
  }
  @if (loading === true) {
    <ion-grid>
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    </ion-grid>
  }
</ion-content>
